var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01997 1.91016C5.70997 1.91016 3.01997 4.60016 3.01997 7.91016V10.8002C3.01997 11.4102 2.75997 12.3402 2.44997 12.8602L1.29997 14.7702C0.589966 15.9502 1.07997 17.2602 2.37997 17.7002C6.68997 19.1402 11.34 19.1402 15.65 17.7002C16.86 17.3002 17.39 15.8702 16.73 14.7702L15.58 12.8602C15.28 12.3402 15.02 11.4102 15.02 10.8002V7.91016C15.02 4.61016 12.32 1.91016 9.01997 1.91016Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8699 2.19994C10.5599 2.10994 10.2399 2.03994 9.90992 1.99994C8.94992 1.87994 8.02992 1.94994 7.16992 2.19994C7.45992 1.45994 8.17992 0.939941 9.01992 0.939941C9.85992 0.939941 10.5799 1.45994 10.8699 2.19994Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.02 18.0601C12.02 19.7101 10.67 21.0601 9.02002 21.0601C8.20002 21.0601 7.44002 20.7201 6.90002 20.1801C6.36002 19.6401 6.02002 18.8801 6.02002 18.0601",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.d165926e742b0742b612470261a5fc31.svg";
export { ForwardRef as ReactComponent };